/**
 * PhysicalProcess CRUD
 */

import type { PhysicalProcess } from '../../graphql/types';
import { createEntityCrudClient } from './crudFactory';

export interface CreatePhysicalProcessInput {
  name: string;
  description?: string;
  processType: string;
  processTier: string;
  processOwnerId: string;
  owningBusinessUnitId: string;
  inputDescription?: string;
  outputDescription?: string;
  estimatedDuration?: string;
  volumePerPeriod?: string;
  automationLevel?: string;
  toolingDescription?: string;
  status?: string;
  tags?: string[];
  notes?: string;
}

export interface UpdatePhysicalProcessInput {
  name?: string;
  description?: string;
  processType?: string;
  processTier?: string;
  processOwnerId?: string;
  owningBusinessUnitId?: string;
  inputDescription?: string;
  outputDescription?: string;
  estimatedDuration?: string;
  volumePerPeriod?: string;
  automationLevel?: string;
  toolingDescription?: string;
  status?: string;
  tags?: string[];
  notes?: string;
}

const client = createEntityCrudClient<
  PhysicalProcess,
  CreatePhysicalProcessInput,
  UpdatePhysicalProcessInput
>('/physical-processes');

export async function createPhysicalProcess(
  input: CreatePhysicalProcessInput
): Promise<PhysicalProcess> {
  return client.create(input);
}

export async function updatePhysicalProcess(
  physicalProcessId: string,
  input: UpdatePhysicalProcessInput
): Promise<PhysicalProcess> {
  return client.update(physicalProcessId, input);
}

export async function deletePhysicalProcess(
  physicalProcessId: string,
  hardDelete: boolean = false
): Promise<void> {
  return client.remove(physicalProcessId, hardDelete);
}
